import { isTeleconsultoriaParticipant } from "./actors";

/**
 * Helpers para distinguir os dois Encounters de um mesmo Appointment:
 * - Encounter de origem (host): sem partOf;
 * - Encounter do teleconsultor: partOf aponta para o Encounter de origem.
 */

type EncounterEntry = { resource?: fhir5.Encounter };

/** Encounter do teleconsultor = tem partOf. */
export function isTeleconsultoriaEncounter(
  encounter: fhir5.Encounter | undefined,
): boolean {
  return Boolean(encounter?.partOf?.reference);
}

/**
 * Primeiro Encounter sem partOf (o do profissional de origem).
 * Ignora:
 * - entered-in-error: Encounter órfão do teleconsultor (falhou antes do partOf);
 * - excludeId: Encounter do teleconsultor recém-criado, ainda sem partOf.
 */
export function pickHostEncounter(
  entries: EncounterEntry[] | undefined,
  excludeId?: string,
): fhir5.Encounter | undefined {
  return entries
    ?.map((entry) => entry?.resource)
    .find(
      (resource) =>
        resource?.resourceType === "Encounter" &&
        !isTeleconsultoriaEncounter(resource) &&
        resource.status !== "entered-in-error" &&
        (!excludeId || resource.id !== excludeId),
    );
}

/** Encounter do teleconsultor ligado ao Encounter de origem informado. */
export function pickGuestEncounter(
  entries: EncounterEntry[] | undefined,
  hostEncounterId: string,
  practitionerRef: string,
): fhir5.Encounter | undefined {
  return entries
    ?.map((entry) => entry?.resource)
    .find(
      (resource) =>
        resource?.partOf?.reference === `Encounter/${hostEncounterId}` &&
        resource.participant?.some(
          (item) => item.actor?.reference === practitionerRef,
        ),
    );
}

/**
 * Practitioner "dono" do Encounter.
 * Com partOf: o marcado como teleconsultor (CON).
 * Sem partOf: o primeiro Practitioner sem a marcação (host).
 */
export function encounterOwnerPractitioner(
  encounter: fhir5.Encounter | undefined,
): fhir5.Reference | undefined {
  const practitioners = (encounter?.participant || []).filter((item) =>
    item.actor?.reference?.includes("Practitioner"),
  );
  const owner = isTeleconsultoriaEncounter(encounter)
    ? practitioners.find(isTeleconsultoriaParticipant)
    : practitioners.find((item) => !isTeleconsultoriaParticipant(item));
  return owner?.actor;
}
